import React from "react";
import PageTitle from "../../../components/partials/PageTitle";
import BusinessInformation from "../../../components/customer/corperate-customer/BusinessInformation";
import ContactInformation from "../../../components/customer/corperate-customer/ContactInformation";
import Identification from "./../../../components/customer/corperate-customer/Identification";
import { useRef } from "react";

const CorporateCustomerApplication = () => {
  let contactInfoRef = useRef();
  let idInfoRef = useRef();

  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Corperate Customer",
      link: "/admin/add-customer",
    },
    current: {
      title: "corporate",
      link: null,
    },
  };

  return (
    <>
      {/* page title */}
      <PageTitle
        title='Corporate Customer Application'
        breadcrumb={breadcrumb}
      />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body p-2'>
              <div className='content border p-2 rounded-2'>
                <h5 className='text-dark text-uppercase'>Basic Information</h5>
                <div className='form-wrapper px-3'>
                  <div className='row'>
                    <ul className='nav nav-tabs mb-'>
                      <li className='nav-item'>
                        <a
                          href='#business'
                          data-bs-toggle='tab'
                          aria-expanded='true'
                          className='nav-link active'
                        >
                          <i className='mdi mdi-account-circle d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Business Information
                          </span>
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          href='#settings'
                          data-bs-toggle='tab'
                          aria-expanded='false'
                          ref={contactInfoRef}
                          className='nav-link'
                        >
                          <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Contact Information
                          </span>
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          href='#identification'
                          data-bs-toggle='tab'
                          aria-expanded='false'
                          ref={idInfoRef}
                          className='nav-link'
                        >
                          <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                          <span className='d-none d-md-block'>
                            Identification
                          </span>
                        </a>
                      </li>
                    </ul>

                    <div className='tab-content px-0 mb-2'>
                      <div className='tab-pane show active ' id='business'>
                        <BusinessInformation contactInfoRef={contactInfoRef} />
                      </div>
                      <div className='tab-pane' id='settings'>
                        <ContactInformation idInfoRef={idInfoRef} />
                      </div>
                      <div className='tab-pane' id='identification'>
                        <Identification />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateCustomerApplication;
